import { render } from "./ContentDetailManajemen.vue?vue&type=template&id=70214fb0&scoped=true"
import script from "./ContentDetailManajemen.vue?vue&type=script&lang=js"
export * from "./ContentDetailManajemen.vue?vue&type=script&lang=js"

import "./ContentDetailManajemen.vue?vue&type=style&index=0&id=70214fb0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70214fb0"]])

export default __exports__